import { AvailableFokParameterChoiceViewModel, FokParameterType } from '@fora-monorepo/employer-my-pages-common/types';

export const mockAvailableFokParameterChoices: AvailableFokParameterChoiceViewModel[] = [
  {
    parameterValue: FokParameterType.AvtalspensionSAFLOAfter65,
    startDate: null,
    endDate: null,
  },
  { parameterValue: FokParameterType.KPAfter65, startDate: null, endDate: null },
];
